import { Box, Icon, Text, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Tooltip from 'modules/reports/components/Editor/FieldSelectorModal/Tooltip'

import * as styles from './index.vanilla.css'

type Props = {
  title: string
  open: boolean
  disabled: boolean
  description?: string
  onOpen: () => void
  onClose: () => void
}

const Category = ({ title, open, description, disabled, onOpen, onClose }: Props) => {
  const [tooltip, tooltipToggle] = useToggle(false)
  const [infoTooltip, infotooltipToggle] = useToggle(false)

  return (
    <Box
      cursor="pointer"
      background="grey000White"
      className={styles.header}
      height="s64"
      paddingX="s16"
      paddingY="s16"
      flexDirection="row"
      justifyContent="spaceBetween"
      onMouseLeave={tooltipToggle(false)}
      onMouseEnter={tooltipToggle(true)}
      onClick={() => {
        if (open) {
          onClose()
        } else {
          onOpen()
        }
      }}
    >
      <Box flexDirection="row" alignItems="center" gap="s4">
        {disabled && tooltip && !infoTooltip && (
          <Tooltip label={i18n.t('custom_reports.editor.incompatible_field_selection')} />
        )}
        <Text.Header3 {...(disabled ? { color: 'grey600' } : {})}>{title}</Text.Header3>
        {description && (
          <Box onMouseEnter={infotooltipToggle(true)} onMouseLeave={infotooltipToggle(false)}>
            <Icon.Medium color={disabled ? 'grey600' : 'grey800'} icon="info-circle-line" />
            {infoTooltip && <Tooltip label={description} />}
          </Box>
        )}
      </Box>
      <Box>
        <Icon.Medium icon={open ? 'remove' : 'add'} />
      </Box>
    </Box>
  )
}

export default Category
